/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const fonts = (basePath: string): ThemeOptions => ({
	fonts: [
		{
			family: 'effra',
			style: 'normal',
			display: 'swap',
			weight: 400,
			src: `url(${process.env.NEXT_PUBLIC_ITNL_STORE_CDN_URL}/wchcontent/fonts/Effra_W_Rg.woff) format('woff')`
		},
		{
			family: 'chaloops-bold',
			style: 'normal',
			display: 'swap',
			weight: 400,
			//src: `url(${process.env.NEXT_PUBLIC_ITNL_STORE_CDN_URL}/wchcontent/fonts/Chank_Chaloops_Bold.otf) format('opentype')`
			src: `url(${process.env.NEXT_PUBLIC_ITNL_STORE_CDN_URL}/wchcontent/fonts/New-Chalooops-Bold.otf) format('opentype')`
		},		
		{
			family: 'chaloops-medium',
			style: 'normal',
			display: 'swap',
			weight: 400,
			//src: `url(${process.env.NEXT_PUBLIC_ITNL_STORE_CDN_URL}/wchcontent/fonts/Chank_Chaloops_Medium.ttf) format('opentype')`
			src: `url(${process.env.NEXT_PUBLIC_ITNL_STORE_CDN_URL}/wchcontent/fonts/New-Chalooops-Medium.otf) format('opentype')`
		},		
		{
			family: 'mikado-black',
			style: 'normal',
			display: 'swap',
			weight: 400,
			src: `url(${process.env.NEXT_PUBLIC_ITNL_STORE_CDN_URL}/wchcontent/fonts/MikadoBlack.otf) format('opentype')`
		},
		{
			family: 'mikado-bold',
			style: 'normal',
			display: 'swap',
			weight: 400,
			src: `url(${process.env.NEXT_PUBLIC_ITNL_STORE_CDN_URL}/wchcontent/fonts/MikadoBold.otf) format('opentype')`
		},
		{
			family: 'mikado-light',
			style: 'normal',
			display: 'swap',
			weight: 400,
			src: `url(${process.env.NEXT_PUBLIC_ITNL_STORE_CDN_URL}/wchcontent/fonts/MikadoLight.otf) format('opentype')`
		},
		{
			family: 'mikado-medium',
			style: 'normal',
			display: 'swap',
			weight: 400,
			src: `url(${process.env.NEXT_PUBLIC_ITNL_STORE_CDN_URL}/wchcontent/fonts/MikadoMedium.otf) format('opentype')`
		},
		{
			family: 'mikado-regular',
			style: 'normal',
			display: 'swap',
			weight: 400,
			src: `url(${process.env.NEXT_PUBLIC_ITNL_STORE_CDN_URL}/wchcontent/fonts/MikadoRegular.otf) format('opentype')`
		}
	],
});
